import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "py-6" }
const _hoisted_2 = {
  key: 0,
  class: "py-12"
}

import { onMounted, ref, computed } from 'vue';
import { usePaymentStore } from '@/store';
import { PaymentServices } from '@/services/store';
import { APPLE_PAY_SDK } from '@/constants/urls.const';


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentSectionApplePay',
  props: {
    merchantName: { default: 'RACQ' }
  },
  setup(__props: any) {

const props = __props;

const paymentStore = usePaymentStore();

const isAvailable = ref(false);

onMounted(async () => {
  await loadApplePayJs();
  try {
    // Guard Apple Pay availability
    // canMakePayments may return a Promise in some browsers; coerce to boolean
    const supported = typeof (window as any).ApplePaySession !== 'undefined';
    if (supported) {
      const canPay = (window as any).ApplePaySession.canMakePayments?.();
      isAvailable.value = typeof canPay === 'boolean' ? canPay : true;
    }
  } catch {
    isAvailable.value = false;
  }
});

const loadApplePayJs = () => {
  return new Promise((resolve) => {
    if ((window as any)?.ApplePaySDK && (window as any)?.ApplePaySession) return resolve(1);
    const element = document.createElement('script');
    element.addEventListener('load', resolve, { once: true });
    element.src = APPLE_PAY_SDK;
    element.crossOrigin = 'anonymous';
    document.head.appendChild(element);
  });
};

const totalAmount = computed(() => {
  const amt = Number(paymentStore.amount || '0');
  return isNaN(amt) ? '0.00' : amt.toFixed(2);
});

const fireApplePay = async () => {
  const ApplePaySession = (window as any).ApplePaySession;
  if (!ApplePaySession) return;

  // Build Apple Pay payment request from store values
  const request: any = {
    countryCode: 'AU',
    currencyCode: 'AUD',
    merchantCapabilities: ['supports3DS'],
    supportedNetworks: ['visa', 'masterCard', 'amex'],
    total: {
      label: props.merchantName || 'RACQ',
      type: 'final',
      amount: totalAmount.value,
    },
  };

  // Create ApplePaySession
  const session = new ApplePaySession(3, request);

  // Merchant validation via Forms API proxy -> Online Services -> Apple
  session.onvalidatemerchant = async (event: any) => {
    console.log('onvalidatemerchant', event);

    try {
      const merchantSession = await PaymentServices.createApplePayMerchantSession({
        url: event?.validationURL,
        domainName: window.location.hostname,
        displayName: props.merchantName || 'RACQ',
      });
      session.completeMerchantValidation(merchantSession);
    } catch (err) {
      // Fail validation gracefully
      console.error('Apple Pay merchant validation failed', err);
      try {
        session.abort();
      } catch (e) {
        // ignore abort error if session already completed/aborted
      }
    }
  };

  // Tokenization/authorization
  session.onpaymentauthorized = async (event: any) => {
    try {
      // Extract the token payload (structure may vary by browser)
      const tokenObj =
        event?.payment?.token ??
        event?.payment?.token?.paymentData ??
        event?.payment?.token?.paymentData?.data ??
        event?.payment;

      // Persist raw token into shared store to keep downstream flows consistent
      const rawToken =
        typeof tokenObj === 'string' ? tokenObj : JSON.stringify(tokenObj ?? { reason: 'missing_token' });

      // store token and trigger existing submit flow
      paymentStore.setApplePayToken(rawToken);

      session.completePayment({ status: ApplePaySession.STATUS_SUCCESS });
    } catch (err) {
      console.error('Apple Pay authorization failed', err);
      session.completePayment({ status: ApplePaySession.STATUS_FAILURE });
    }
  };

  session.oncancel = () => {
    // User canceled
  };

  session.begin();
};

return (_ctx: any,_cache: any) => {
  const _component_apple_pay_button = _resolveComponent("apple-pay-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-base-bold" }, "Continue with Apple Pay", -1)),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-base-regular mt-2" }, "Check out is quick and secure with Apple Pay.", -1)),
    (isAvailable.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_apple_pay_button, {
            buttonstyle: "white-outline",
            type: "pay",
            locale: "en-AU",
            onClick: fireApplePay
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})